export default __webpack_public_path__ + "static/media/logo.26e7dd40.jpg";